import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Column,
  Icon,
  Popover,
  PopoverLauncher,
  PopoverContent,
  ToggleSwitch,
  ToggleSwitchOnLabel,
  ToggleSwitchOffLabel,
  Button,
  H3,
} from "@vp/swan";
import l10n from "../../localization/localization";
import styles from "../../styles/cookie-message-style.scss";
import { Mode } from "../../constants";

export default class PreferenceCategory extends PureComponent {
  static propTypes = {
    category: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    mode: PropTypes.string.isRequired,
  };

  render() {
    const { category, handleChange, mode } = this.props;

    const { contentPosition, togglePosition } = this.getPosition(mode);

    const getCategoryId = (category) => `${category.name}CategoryLabel`;

    const showPopover = l10n.exists(
      `preferenceDialogV5.categories.${category.name}.popover`,
    );
    return (
      <Fragment>
        <Row marginBottom="5">
          <Column verticallyCenterContent {...contentPosition}>
            <Row marginBottom="3">
              <Column span={12}>
                <Row>
                  <Column span={12} display="flex" alignitems="center">
                    <H3
                      title={l10n.t(
                        `preferenceDialogV5.categories.${category.name}.header`,
                      )}
                      textAlign="left"
                      fontWeight="bold"
                      fontSize="large"
                      id={getCategoryId(category)}
                    >
                      {l10n.t(
                        `preferenceDialogV5.categories.${category.name}.header`,
                      )}
                    </H3>
                    {showPopover && (
                      <Popover
                        position="right"
                        className={styles.categoryDetailsPopover}
                        paddingLeft={"3"}
                      >
                        <PopoverLauncher>
                          <Button
                            skin="unstyled"
                            aria-label={l10n.t(
                              `preferenceDialogV5.categories.${category.name}.iconAccessibility`,
                            )}
                          >
                            <Icon
                              skin="standard"
                              iconType="info"
                              className={styles.informationIcon}
                            />
                          </Button>
                        </PopoverLauncher>
                        <PopoverContent
                          id="category-details-popover-content"
                          className={styles.categoryDetailsPopoverContent}
                          role="status"
                        >
                          {l10n.t(
                            `preferenceDialogV5.categories.${category.name}.popover`,
                          )}
                        </PopoverContent>
                      </Popover>
                    )}
                  </Column>
                </Row>
              </Column>
            </Row>
            <Row>
              <Column span={12}>
                {l10n.t(
                  `preferenceDialogV5.categories.${category.name}.content`,
                )}
              </Column>
            </Row>
          </Column>
          <Column {...togglePosition} align="right">
            <ToggleSwitch
              name={category.name}
              className={styles.toggleSwitchDisabled}
              aria-labelledby={getCategoryId(category)}
              onRequestActivatedChange={
                !category.readonly
                  ? (activated) => handleChange(category.name, activated)
                  : () => {}
              }
              activated={category.enabled}
              disabled={category.readonly}
            >
              <ToggleSwitchOnLabel>
                {l10n.t("preferenceDialog.toggleOn")}
              </ToggleSwitchOnLabel>
              <ToggleSwitchOffLabel>
                {l10n.t("preferenceDialog.toggleOff")}
              </ToggleSwitchOffLabel>
            </ToggleSwitch>
          </Column>
        </Row>
      </Fragment>
    );
  }

  getPosition(mode) {
    if (mode === Mode.Embedded) {
      return {
        contentPosition: {
          span: 10,
          spanXs: 8,
        },
        togglePosition: {
          span: 2,
          spanXs: 4,
        },
      };
    }

    return {
      contentPosition: {
        offsetLg: 3,
        spanLg: 5,
        offset: 1,
        span: 9,
        spanXs: 7,
      },
      togglePosition: {
        span: 1,
        spanXs: 2,
      },
    };
  }
}
